import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Tree = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 2C21.514 2 26 6.486 26 12V16C26 20.829 22.559 24.87 18 25.799V29C18 29.552 17.552 30 17 30C16.448 30 16 29.552 16 29V26C10.486 26 6 21.514 6 16V12C6 6.486 10.486 2 16 2ZM8 16C8 20.411 11.589 24 16 24V19.535C14.611 18.609 10.445 15.832 10.445 15.831C10.177 15.652 10 15.346 10 14.999C10 14.447 10.448 13.999 11 13.999C11.205 13.999 11.395 14.061 11.553 14.166C11.553 14.166 14.222 15.945 16 17.13V8.998C16 8.446 16.448 7.998 17 7.998C17.552 7.998 18 8.446 18 8.998V12.584C19.088 11.496 20.294 10.291 20.294 10.291C20.475 10.11 20.724 9.999 21 9.999C21.552 9.999 22 10.447 22 10.999C22 11.275 21.888 11.524 21.708 11.705C21.708 11.705 18.921 14.492 18 15.413V23.746C21.447 22.856 24 19.72 24 15.999V11.999C24 7.588 20.411 3.999 16 3.999C11.589 3.999 8 7.588 8 11.999V15.999V16Z" />
	</svg>
);

export default Tree;
